<template>
  <div>
    <div class="contact_page_banner_out">
      <div class="container">
        <dl class="all_page_banner_txt">
          <dt>联系我们</dt>
          <dd>Contact &nbsp;&nbsp; us</dd>
        </dl>
      </div>
    </div>

    <div class="clearfix container">
      <div class="row">
        <div class="clearfix contact_page_add">
          <dl class="a col-lg-4 col-md-4 col-sm-12 col-xs--12">
            <dt></dt>
            <dd>济南市高新区正丰路554号环保科技园B座南楼501室</dd>
          </dl>
          <dl class="b col-lg-4 col-md-4 col-sm-12 col-xs--12">
            <dt></dt>
            <dd>0531-88995916</dd>
          </dl>
          <dl class="c col-lg-4 col-md-4 col-sm-12 col-xs--12">
            <dt></dt>
            <dd>sdzzdzkj@163.com</dd>
          </dl>
        </div>
      </div>
    </div>
    <!-- 表格展示 -->
    <div class="contact-table row">
      <table class=" col-lg-7">
        <tr>
          <td>联系人</td>
          <td>负责区域</td>
          <td>联系电话</td>
        </tr>
        <tr v-for="item in userList" :key="item.iphone">
          <td>{{ item.name }}</td>
          <td>{{ item.region }}</td>
          <td>{{ item.iphone }}</td>
        </tr>
        <!-- <tr>
          <td>向经理</td>
          <td>福建、广东、广西、海南</td>
          <td>15552518619</td>
        </tr>
        <tr>
          <td>杨经理</td>
          <td>河南、安徽、江西</td>
          <td>15552512685</td>
        </tr>
        <tr>
          <td>刘经理</td>
          <td>湖南、湖北</td>
          <td>15552517696</td>
        </tr>
        <tr>
          <td>巩经理</td>
          <td>黑龙江、吉林、内蒙古、辽宁</td>
          <td>15552519208</td>
        </tr>
        <tr>
          <td>周经理</td>
          <td>四川、重庆、贵州、云南</td>
          <td>15552516792</td>
        </tr>
        <tr>
          <td>李经理</td>
          <td>河北、北京、山西、天津</td>
          <td>15552516135</td>
        </tr>
        <tr>
          <td>闫经理</td>
          <td>江苏、上海、浙江</td>
          <td>15552510597</td>
        </tr>
        <tr>
          <td>巩经理</td>
          <td>山东、西藏、陕西、青海、新疆、宁夏</td>
          <td>13075363230</td>
        </tr> -->
      </table>
    </div>

    <div class="container">
      <div class="row">
        <ul class="clearfix contact_message">
          <li class="a">
            <i style="color: red">*</i>
            <input
              type="text"
              value
              placeholder="姓名NAME:"
              v-model="formData.name"
              style="width: 90%"
            />
          </li>
          <li class="a">
            <i style="color: red">*</i>
            <input
              type="text"
              value
              placeholder="电话TEL："
              v-model="formData.tel"
              style="width: 90%"
            />
          </li>
          <li class="a c">
            <i style="color: red">*</i>
            <input
              type="text"
              value
              placeholder="邮箱EMAIL："
              v-model="formData.email"
              style="width: 90%"
            />
          </li>
          <li class="textarea">
            <textarea
              placeholder="留言内容MESSAGE："
              v-model="formData.message"
              style="height: 150px"
            ></textarea>
          </li>
          <li class="button">
            <input type="button" value="提交留言" @click="submit()" />
          </li>
        </ul>
      </div>
    </div>
    <div class="contact_page_map_out" style="margin: 6% 0 8%">
      <div id="dituContent">
        <baidu-map
          ak="YOUR_APP_KEY"
          class="bmView"
          :scroll-wheel-zoom="true"
          :center="center"
          :zoom="zoom"
          :position="center"
        >
          <bm-view style="width: 100%; height: 450px; flex: 1"></bm-view>
          <!-- <bm-local-search :keyword="addressKeyword" :auto-viewport="true" style="display: none"></bm-local-search> -->
          <bm-marker
            :position="center"
            :dragging="true"
            :title="storeName"
            :zIndex="999999999"
          >
            <bm-info-window :show="isShowInfo">{{ address }}</bm-info-window>
          </bm-marker>
        </baidu-map>
        <!-- <div id="XSDFXPage" class="XSDFXPage"></div> -->
      </div>
    </div>
  </div>
</template>
<script>
import "../../static/css/swiper.min.css";
import "../../static/css/bootstrap.min.css";
import "../../static/css/nav.css";
import "../../static/css/animate.min.css";
import "../../static/css/common.css";
import "../../static/css/style.css";

import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import BmView from "vue-baidu-map/components/map/MapView.vue";
// import BmLocalSearch from "vue-baidu-map/components/search/LocalSearch.vue";
import BmMarker from "vue-baidu-map/components/overlays/Marker"; //点标注
import BmInfoWindow from "vue-baidu-map/components/overlays/InfoWindow"; //标注弹窗

import Qs from "qs";
export default {
  data() {
    return {
      storeName: "",
      center: { lng: 117.118773, lat: 36.6935 },
      zoom: 15,
      isShowInfo: true,
      address: "山东泽众电子科技有限公司 ",
      formData: { name: "", tel: "", email: "", message: "" },
      userList:[]
    };
  },
  components: {
    BaiduMap,
    BmView,
    BmMarker,
    BmInfoWindow,
  },
  mounted() {
    this.userList = this.config.companyUserList;
  },
  methods: {
    //提交验证
    changeSubmit() {
      //formData.name formData.tel formData.email formData.message
      // 姓名NAME  电话TEL 邮箱EMAIL 留言内容
      if (
        this.formData.name === "" ||
        this.formData.name === null ||
        this.formData.name === undefined
      ) {
        this.$Message.error("请输入姓名");
        return false;
      } else if (this.formData.tel === "" || this.formData.tel === undefined) {
        this.$Message.error("请输入电话");
        return false;
      } else if (
        this.formData.email === "" ||
        this.formData.email === undefined
      ) {
        this.$Message.error("请输入邮箱");
        return false;
      }
      //formData.Sort
      if (
        this.formData.message === "" ||
        this.formData.message === undefined ||
        this.formData.message === null
      ) {
        this.$Message.error("请输入留言内容！");
        return false;
      } else {
        return true;
      }
    },
    submit() {
      var t = this.changeSubmit();
      if (t) {
        var posturl = this.config.baseUrl.pro + "/Base_NewsMessage/apiAdd";
        axios
          .request({
            url: posturl,
            method: "Post",
            changeOrigin: true,
            data: Qs.stringify(this.formData),
          })
          .then((resp) => {
            if (resp.data.result == "新增成功") {
              this.$Message.success("发送成功");
              this.formData = { name: "", tel: "", email: "", message: "" };
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/view/contact.vue